import {
  SET_ORIGIN,
  SET_ALERT_MODAL,
  SET_PROMPT_MODAL,
  SET_POLICY_TYPE,
  SET_LOADING,
  SET_BUTTON_HEADER,
  GET_CONFIG,
  SET_VIEW,
  SET_VISIBLE_SELECTORS,
  SET_APP,
  SET_ANONYMOUS,
  GET_IDLE_SETTINGS,
} from "../actions/app";

const initialState = {
  view: null,
  config: null,
  isLoading: false,
  origin: {},
  policyType: { personal: false, commercial: false, active: "" },
  alertModal: { show: false, type: "info", body: "Default Message" },
  promptModal: { show: false, properties: null },
  buttonHeaderShowing: false,
  visibleSelectors: {
    auto: false,
    property: false,
    liability: false,
    home: false,
    wc: false,
    vehicle: false
  },
  app: null,
  isAnonymous: true,
  idleSettings: {timeout: 1200000, promptBeforeIdle: 300000},//hardcoding to default to avoid errors before loads
};

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFIG:
      return { ...state, config: action.config };
    case SET_VIEW:
      return { ...state, view: action.view };
    case SET_LOADING:
      return { ...state, isLoading: action.isLoading };
    case SET_ORIGIN:
      return { ...state, origin: action.origin };
    case SET_ALERT_MODAL:
      return { ...state, alertModal: action.alert };
    case SET_PROMPT_MODAL:
      return {...state, promptModal: action.prompt};
    case SET_POLICY_TYPE:
      return { ...state, policyType: action.policyType };
    case SET_BUTTON_HEADER:
      return { ...state, buttonHeaderShowing: action.isShowing };
    case SET_VISIBLE_SELECTORS:
      return {
        ...state,
        visibleSelectors: {
          auto: action.auto,
          property: action.property,
          liability: action.liability,
          home: action.home,
          wc: action.wc,
          vehicle: action.vehicle,
        },
      };
    case SET_APP:
      return { ...state, app: action.app };
    case SET_ANONYMOUS:
      return { ...state, isAnonymous: action.isAnonymous };
    case GET_IDLE_SETTINGS:
      return { ...state, idleSettings: action.settings };
    default:
      return { ...state };
  }
};
